import React, { useState } from 'react'
import Field from '../../common/FormField'
import PasswordStrengthRules from '../../common/PasswordStrengthRules'
import styles from './Password.module.css'

function PasswordInput({ placeholder, value, onChange, disabled }) {
  const [visible, setVisible] = useState(false)
  return (
    <div className={styles.wrapper}>
      <input
        type={visible ? 'text' : 'password'}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setVisible(v => !v)}
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        <i className={`fa ${visible ? 'fa-eye-slash' : 'fa-eye'}`} />
      </button>
    </div>
  )
}

export default ({ data, error = {}, onChangeFactory, disabled }) =>
  <fieldset>
    <Field type="input" name="Old Password *" error={error.oldPassword}>
      <PasswordInput
        placeholder="Enter old password"
        value={data.oldPassword}
        onChange={onChangeFactory('oldPassword')}
        disabled={disabled}
      />
    </Field>
    <Field type="input" name="New Password *" error={error.password}>
      <PasswordInput
        placeholder="Enter new password"
        value={data.password}
        onChange={onChangeFactory('password')}
        disabled={disabled}
      />
    </Field>
    <PasswordStrengthRules password={data.password} />
    <Field type="input" name="Confirm Password *" error={error.verifyPassword}>
      <PasswordInput
        placeholder="Enter new password again"
        value={data.verifyPassword}
        onChange={onChangeFactory('verifyPassword')}
        disabled={disabled}
      />
    </Field>
  </fieldset>
